module.exports = __webpack_public_path__ + "img/logo_login_inferiore.8e4b88c6.png";